import { mutate } from 'swr';
import { LAB_SWR_KEY_PREFIXES } from '../pages/prontuario/exames-laboratoriais/examesLaboratoriaisApi';

export const CONVENIOS_SWR_KEY = 'careplan';
export const PROCEDIMENTOS_SWR_KEY = 'procedimentos';
export const DETALHES_SWR_KEY = 'procedimento/convenio';
export const TIPOEXAME_SWR_KEY = 'tipoexame';

export const clearCache = () => {
  mutate(CONVENIOS_SWR_KEY, undefined, { revalidate: false });
  mutate(PROCEDIMENTOS_SWR_KEY, undefined, { revalidate: false });
  mutate(DETALHES_SWR_KEY, undefined, { revalidate: false });
  mutate(TIPOEXAME_SWR_KEY, undefined, { revalidate: false });
  mutate(
    key => Array.isArray(key) && LAB_SWR_KEY_PREFIXES.includes(key[0]),
    undefined,
    { revalidate: false }
  );
};

export const revalidateCadastroOperacional = () => {
  mutate(CONVENIOS_SWR_KEY);
  mutate(PROCEDIMENTOS_SWR_KEY);
  mutate(DETALHES_SWR_KEY);
};
